// Mock data for Sreeja's Portfolio

export const personalInfo = {
  name: "Sreeja G",
  title: "Software Engineer & AI Enthusiast",
  tagline: "Building intelligent solutions with code & creativity",
  email: "gsreeja111@gmail.com",
  phone: "+91 9000314996",
  linkedin: "https://www.linkedin.com/in/gsreeja",
  github: "https://github.com/gsreeja",
  location: "India"
};

export const about = {
  summary: "A highly analytical and results-driven engineer with hands-on experience in technical and engineering support for complex systems and products. Skilled in API integrations, full-stack development, machine learning, and using data to resolve operational issues. Experienced in working with Large Language Models (LLMs) and developing AI-driven solutions.",
  education: {
    degree: "Bachelor of Technology in Computer Science and Engineering (Data Science)",
    university: "JAIN (Deemed-to-be University)",
    cgpa: "8.1",
    graduationDate: "August 2024"
  }
};

export const workExperience = [
  {
    id: 1,
    title: "Junior Software Engineer (Research)",
    company: "IIIT Hyderabad",
    duration: "Sep 2024 - Dec 2024",
    description: [
      "Provided proactive and reactive technical support as part of a cross-functional research team, investigating and resolving issues with state-of-the-art LLMs to ensure high product quality and a satisfactory partner experience.",
      "Spearheaded efforts to assemble comprehensive datasets for 12+ low-resource Indian languages, establishing industry benchmarks and using the data to improve model metrics and provide key insights for continuous product improvements."
    ],
    tags: ["LLMs", "Research", "Data Engineering", "AI"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Open Source Contributions",
    category: "Open Source",
    description: "Active contributor to major Python libraries including scipy and scikit-learn, helping improve scientific computing tools used by millions of developers worldwide.",
    technologies: ["Python", "NumPy", "Machine Learning"],
    link: "https://github.com/scipy/scipy",
    featured: true
  },
  {
    id: 2,
    title: "Emotion Based Music Recommendation System",
    category: "AI/ML",
    description: "Built and deployed a system using a CNN model to predict emotions from live video and recommend songs. Integrated payment gateways and authored a research paper on the system.",
    technologies: ["Python", "Deep Learning", "Flask", "Image Processing", "CNN"],
    featured: true
  },
  {
    id: 3,
    title: "Sentiment Analysis on Twitter & Movie Reviews",
    category: "NLP",
    description: "Optimized model accuracy achieving up to 88% with deep learning models. Managed project from data cleaning to model optimization.",
    technologies: ["Python", "NLP", "Jupyter Notebook", "Deep Learning"],
    featured: false
  }
];

export const achievements = [
  {
    id: 1,
    title: "TCS Codevita 2024",
    rank: "317 / 100,000+",
    percentile: "99th",
    description: "Demonstrated strong algorithmic thinking and problem-solving abilities",
    year: "2024",
    icon: "trophy"
  },
  {
    id: 2,
    title: "ICPC AlgoQueen Preliminary",
    rank: "389",
    percentile: "Top 10%",
    description: "Secured rank in the ICPC AlgoQueen coding contest",
    year: "2024",
    icon: "award"
  },
  {
    id: 3,
    title: "Hackerearth September Circuits",
    rank: "67 / 2000+",
    percentile: "98.2th",
    description: "Worldwide ranking with overall coding rating of 1682",
    year: "2023",
    icon: "star"
  },
  {
    id: 4,
    title: "Techgig Geek Goddess Challenge",
    rank: "Finalist",
    percentile: "90th",
    description: "Finalist in the coding round",
    year: "2023",
    icon: "medal"
  },
  {
    id: 5,
    title: "HackerRank DSA Certified",
    rank: "Certified",
    percentile: "",
    description: "Standardized assessment for DSA capabilities",
    year: "2023",
    icon: "certificate"
  }
];

export const skills = {
  languages: ["Python", "C/C++", "Java", "PHP", "Hack", "JavaScript", "Rust"],
  technologies: ["REST API", "SOAP API", "SQL", "Flask", "Django", "GCP", "AWS", "Azure"],
  tools: ["Git", "GitHub", "VS Code", "Visual Studio", "PyCharm", "Eclipse", "Xcode"],
  expertise: [
    "Full Stack Development",
    "Machine Learning",
    "Networking",
    "Database",
    "Data Engineering",
    "Product Analytics",
    "API Integrations",
    "LLM Development",
    "AI-driven Solutions"
  ]
};

export const categories = ["All", "AI/ML", "Open Source", "NLP"];
